module.exports = __webpack_public_path__ + "static/media/005.9fa22ae9.jpg";